export const countries = [
    { name: 'United States', code: 'US' },
];
